export interface BundleUpdateCheckResponse {
  data: BundleUpdateCheckResponseData;
}

export interface BundleUpdateCheckResponseData {
  workflowId: string;
  legalApproved: boolean;
  wifiSignalEnough: boolean;
  diagStackInstancesAvailable: boolean;
  oneTimeLegalApproved: boolean;
}

export interface BundleUpdateTriggerResponse {
  data: BundleUpdateData;
}

export interface BundleUpdateTriggerResponseData {
  workflowId: string;
  legalApproved: string;
  wifiSignalEnough: string;
  diagStackInstancesAvailable: string;
}

export interface BundleUpdateStatusResponse {
  data: BundleUpdateData;
  hasError: boolean;
  errorModel: BundleUpdateErrorModel;
}

export interface BundleUpdateErrorModel {
  viErrorId?: string;
  statusCode?: number;
  errorType?: string;
  message?: string;
  extendedPayload?: ComponentVerification;
}

export interface OTAVersion {
  otaType?: string;
  version: string;
}

export interface BundleVersion {
  ecuName: string;
  otaVersions: OTAVersion[];
  isMissing?: boolean;
}

export interface BundleVersionListItem {
  ecuName?: string;
  otaVersion: string;
}

export interface VerificationMessage {
  id: string;
  title: string;
  description: string;
  errorStatus: string;
  status: boolean;
}

export interface Xota2OperationProcessItem {
  id: string;
  status: Xota2UpdateProgress;
}

export interface BundleUpdateData
  extends ComponentVerificationBoolean,
    MissingBusTopology,
    XotaOperationStatus {
  processType: BundleUpdateProcessTypeEnum;
  progress: BundleUpdateProgressEnum;
  status: BundleUpdateStatusEnum;
  isInUpdateTimeBlock: boolean;
  updateIsAvailable: boolean;
  currentBundleVersion: BundleVersion[];
  targetBundleVersion: BundleVersion[];
  startTimestamp: Date;
  finishedTimestamp: Date;
  overallProgress: number;
}

export interface ComponentVerification {
  legalApproved: string;
  wifiSignalEnough: string;
  diagStackInstancesAvailable: string;
  oneTimeLegalApproved: string;
}

export interface ComponentVerificationBoolean {
  legalApproved: boolean;
  wifiSignalEnough: boolean;
  diagStackInstancesAvailable: boolean;
  oneTimeLegalApproved: boolean;
}

export interface MissingBusTopology {
  missingTcu63InBusTopology: boolean;
  othersEcusMissingInBusTopology: boolean;
  missingEcusInTopology: string;
}

export interface XotaOperationStatus {
  tcuStatus: Xota2UpdateProgress;
  updateMethod: Xota2UpdateProgress;
  containerStatus: Xota2UpdateProgress;
  transferStatus: Xota2UpdateProgress;
  updateStatus: Xota2UpdateProgress;
  reportStatus: Xota2UpdateProgress;
}

export interface VersionListParams {
  processType: BundleUpdateProcessTypeEnum;
  progress: BundleUpdateProgressEnum;
  status: BundleUpdateStatusEnum;
  overallProgress: number;
  missingBusTopology: MissingBusTopology;
  currentBundleVersion: BundleVersion[];
  targetBundleVersion: BundleVersion[];
  isLoading: boolean;
}

export interface BundleUpdateVerifyGateway {
  filterType: string;
  priority: number;
  name: string;
  filter: string;
  isAllowed: boolean;
}

export enum BundleUpdateProcessTypeEnum {
  CheckForBundleUpdate = 'check_for_bundle_update',
  BundleUpdate = 'bundle_update',
}

export enum BundleUpdateProgressEnum {
  Scheduled = 'scheduled',
  Ongoing = 'ongoing',
  Finished = 'finished',
}

export enum BundleUpdateStatusEnum {
  Successful = 'successful',
  Failed = 'failed',
}

export enum BundleUpdateOtaType {
  FOTA = 'FOTA',
  POTA = 'POTA',
}

export enum ComponentVerficationBooleanValue {
  TRUE = 'True',
  FALSE = 'False',
  NULL = 'null',
}

export enum ComponentVerficationTypeValue {
  LEGAL_APPROVED = 'legalApproved',
  WIFI_SIGNAL_ENOUGH = 'wifiSignalEnough',
  DIAGSTACK_INSTANCES_AVAILABLE = 'diagStackInstancesAvailable',
}

export enum Xota2OperationProcessId {
  TCU_STATUS = 'tcuStatus',
  VERIFYING_UPDATE_METHOD = 'updateMethod',
  ZIP_SERVICES = 'containerStatus',
  FILE_TRANSFER = 'transferStatus',
  UPDATE = 'updateStatus',
  REPORT_GENERATION = 'reportStatus',
}

export enum Xota2UpdateProgress {
  WAITING = 'waiting',
  COMPLETED = 'completed',
  UPDATING = 'updating',
  PENDING = 'pending',
  UPDATED = 'updated',
  CREATED = 'created',
  FAILED = 'failed',
  SENDING = 'sending',
  READ = 'read',
  SENT = 'sent',
  NULL = 'null',
  NOT_EXECUTED = 'not_executed',
  UPDATES_NOT_AVAILABLE = 'updates_not_available',
  XOTA_ONE = 'xota1',
  XOTA_TWO = 'xota2',
}

export enum XotaBundleUpdateStep {
  CHECK_FOR_UPDATE = 'check_for_update',
  CHECK_FOR_VERIFICATION = 'check_for_verification',
  UPDATING = 'updating',
  FINALIZE = 'finalize',
}
